import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';

const TrackParameters = ({ 
    data = {}, 
    onAction, 
    t = {} 
}) => {
    const [state, setState] = useState({
        name: data.name || '',
        value: data.value || ''
    });

    const onChangeField = useCallback((event) => {
        const name = event.target.name;
        const value = event.target.value;
        
        setState(prevState => {
            const newState = {
                ...prevState,
                [name]: value
            };

            onAction && onAction(newState);

            return newState;
        });
    }, [onAction]);

    const staticNames = t.postbackPage?.creatingEditing || {};

    return (
        <React.Fragment>
            <h4 className="bold subtitle">{staticNames.trackParameters}</h4>
            <div className="row form-group">
                <div className="form-input">
                    <input
                        className="form-control input-sm"
                        type="text"
                        name="name"
                        value={state.name}
                        placeholder={staticNames.name}
                        onChange={onChangeField}
                    />
                </div>
                <div className="form-input">
                    <input
                        className="form-control input-sm"
                        type="text"
                        name="value"
                        value={state.value}
                        placeholder={staticNames.value}
                        onChange={onChangeField}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

TrackParameters.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onAction: PropTypes.func,
    t: PropTypes.object
};

export default withTranslation(TrackParameters);